package com.example.readingnotes.data.repository

import com.example.readingnotes.data.remote.api.ApiClient
import com.example.readingnotes.data.remote.dto.UpdateNotificationSettingsRequestDto
import com.example.readingnotes.data.remote.mapper.toDomain
import com.example.readingnotes.domain.model.NotificationSettings
import com.example.readingnotes.domain.model.PaginatedNotifications
import com.example.readingnotes.domain.repository.NotificationRepository
import com.example.readingnotes.util.Result

class NotificationRepositoryImpl(
    private val apiClient: ApiClient,
) : NotificationRepository {
    override suspend fun getSettings(): Result<NotificationSettings> =
        try {
            val response = apiClient.getNotificationSettings()
            Result.success(response.toDomain())
        } catch (e: Exception) {
            Result.failure(e)
        }

    override suspend fun updateSettings(settings: NotificationSettings): Result<NotificationSettings> =
        try {
            val request =
                UpdateNotificationSettingsRequestDto(
                    enableNewPost = settings.enableNewPost,
                    enableNewComment = settings.enableNewComment,
                    enableCommentReply = settings.enableCommentReply,
                    enableMention = settings.enableMention,
                    enableSystem = settings.enableSystem,
                    muteStart = settings.muteStart,
                    muteEnd = settings.muteEnd,
                )
            val response = apiClient.updateNotificationSettings(request)
            Result.success(response.toDomain())
        } catch (e: Exception) {
            Result.failure(e)
        }

    override suspend fun getNotifications(
        limit: Int,
        offset: Int,
        unreadOnly: Boolean,
    ): Result<PaginatedNotifications> =
        try {
            val response = apiClient.getNotifications(limit, offset, unreadOnly)
            Result.success(response.toDomain())
        } catch (e: Exception) {
            Result.failure(e)
        }

    override suspend fun markAsRead(id: String): Result<Boolean> =
        try {
            val response = apiClient.markNotificationAsRead(id)
            Result.success(response.success)
        } catch (e: Exception) {
            Result.failure(e)
        }

    override suspend fun markAllAsRead(): Result<Int> =
        try {
            val response = apiClient.markAllNotificationsAsRead()
            Result.success(response.count)
        } catch (e: Exception) {
            Result.failure(e)
        }
}
